var map = {
	"./Accordion.svg": 530,
	"./Breadcrumb.svg": 531,
	"./Button.svg": 532,
	"./Checkbox.svg": 533,
	"./Code snippet.svg": 534,
	"./Content switcher.svg": 535,
	"./Data table.svg": 536,
	"./Date picker.svg": 537,
	"./Dropdown.svg": 538,
	"./File uploader.svg": 539,
	"./Form.svg": 540,
	"./Inline loading.svg": 541,
	"./Link.svg": 542,
	"./List.svg": 543,
	"./Loading.svg": 544,
	"./Modal.svg": 545,
	"./Multiselect.svg": 546,
	"./NoImage.svg": 327,
	"./Notification.svg": 547,
	"./Number input.svg": 548,
	"./Overflow menu.svg": 549,
	"./Pagination.svg": 550,
	"./Progress indicator.svg": 551,
	"./Radio button.svg": 552,
	"./Search.svg": 553,
	"./Select.svg": 554,
	"./Slider.svg": 555,
	"./Structured list.svg": 556,
	"./Tabs.svg": 557,
	"./Tag.svg": 558,
	"./Text input.svg": 559,
	"./Tile.svg": 560,
	"./Toggle.svg": 561,
	"./Tooltip.svg": 562,
	"./UI shell.svg": 563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 529;